var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"page-box"},[_c('img',{staticClass:"no-page",attrs:{"src":require("../image/404.svg")}}),_vm._v(" "),_c('div',[_c('p',{staticClass:"tips"},[_vm._v("这次运气差，页面跑丢了")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.goBack()}}},[_vm._v("返回重试")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189d8076","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/404.vue
// module id = null
// module chunks = 